export default __webpack_public_path__ + "static/media/Foto25.5a3502a9.png";